export const getAuthorities = path => {
  const menus = JSON.parse(localStorage.getItem('menus')) || []

  for (let i = 0; i < menus.length; i++) {
    if (menus[i].route === path) {
      // sessionStorage.setItem('authorities', JSON.stringify(menus[i].authorities))
      return menus[i].authorities
    }
    if (menus[i].children?.length) {
      for (let j = 0; j < menus[i].children.length; j++) {
        if (menus[i].children[j].route === path) {
          // sessionStorage.setItem('authorities', JSON.stringify(menus[i].children[j].authorities))
          return menus[i].children[j].authorities
        }
      }
    }
  }

  return []
}